import modal from './src/';

export default modal;



// WEBPACK FOOTER //
// ./src/components/modal/index.js